import { AuthenticationService } from '@services/authentication.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmacionComponent } from './shared/components/confirmacion/confirmacion.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { GapiSession } from 'src/infraestructure/sessions/gapi.session';
import { AppSession } from 'src/infraestructure/sessions/app.session';
import { UserSession } from 'src/infraestructure/sessions/user.session';
import { AppRepository } from 'src/infraestructure/repositories/app.repository';
import { UserRepository } from 'src/infraestructure/repositories/user.repository';
import { environment } from '@environments/environment';
import { CoreLibModule, LayoutModule } from 'dvt-lib';

export function initGapi(authenticationService: AuthenticationService) {
  return () => authenticationService.initClient();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    NgxMaterialTimepickerModule,
    // Vex
    VexModule,

    LayoutModule,
    CoreLibModule.forRoot({
      production: environment.production,
      authConfig: environment.authConfig,
      authModuleConfig: {
        resourceServer: {
          allowedUrls: [environment.urlBackend, environment.urlBackendAccount], //otras urls que deben llevar el token
          sendAccessToken: true,
        },
      },
      urlBackendAccount: environment.urlBackendAccount,
    }),

  ],
  providers: [{ provide: APP_INITIALIZER, useFactory: initGapi, deps: [AuthenticationService], multi: true },
    AppSession,
    GapiSession,
    UserSession,

    AppRepository,
    UserRepository,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
